import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const vehicleApi = createApi({
  reducerPath: reducerPaths.vehicleApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getVehicle: builder.query({
      query: ({ Vehicle_Id }) => ({
        url: `/seller/vehicle/${Vehicle_Id}`,
        method: "GET",
      }),
    })
  }),
});

export const {
  useGetVehicleQuery,
  useLazyGetVehicleQuery
} = vehicleApi;